/**
 * @file bos配置
 * @author FengGuang(fengguang01@baidu.com)
 */
import request from 'superagent';
import UploadBosClient from '../../utils/bos-client';

export const bucket = 'test';

interface IBosConfig {
    endpoint: string;
    accessKeyId: string;
    secretAccessKey: string;
    sessionToken: string;
    fileKey: string;
    bucketName: string;
}

interface IUploadToBosOptions {
    file: File;
    onProgress?: (percent: number) => any;
}

export const uploadToBos = async (options: IUploadToBosOptions) => {
    // 获取config
    const res = await request.get('/paddlehub/bosacl');
    const config: IBosConfig = res.body.result || {};
    const client = new UploadBosClient({
        bucketName: config.bucketName,
        fileKey: config.fileKey,
        ak: config.accessKeyId,
        sk: config.secretAccessKey,
        sessionToken: config.sessionToken,
        endpoint: config.endpoint,

        file: options.file,
        onProgress: options.onProgress
    });
    client.start();
    return client;
};

export default uploadToBos;
